import $ from 'jquery';
import window from 'window';
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import palette from 'google-palette';

Chart.plugins.unregister(ChartDataLabels);

function toNumber(value) {
    return value ? value < 0 ? 0 : value : 0;
}

function displayChartMonthlyStats(name, selector) {
    if (!$(selector).length) {
        return;
    }

    const yearsRaw = $(selector).attr('data-years');
    const monthsRaw = $(selector).attr('data-months');

    if (!yearsRaw || !monthsRaw) {
        return;
    }

    const years = JSON.parse(yearsRaw.replace(/'/g, '"'));
    const months = JSON.parse(monthsRaw.replace(/'/g, '"'));
    const datasets = [];

    if (years) {
        const baseColors = ['FF7F0E', '1F77B4', '2CA02C'];
        const colors = [...baseColors, ...palette('qualitative', years.length, 5)];
        for (let i = 0; i < years.length; i++) {
            const monthlyRaw = $(selector).attr(`data-year-${i}`);
            const monthly = JSON.parse(monthlyRaw);

            if (monthly && monthly.length > 0) {
                datasets.push({
                    label: `# ${years[i]}`,
                    backgroundColor: `#${colors[i]}`,
                    data: monthly,
                    borderWidth: 1
                });
            }
        }
    }

    const ctx = $(selector);
    window[name] = new Chart(ctx,
        {
            type: 'bar',
            data: {
                labels: months,
                datasets
            },
            options: {
                legend: {
                    position: 'bottom'
                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            drawTicks: false,
                            drawBorder: true,
                            drawOnChartArea: false,
                            z: 1
                        },
                        ticks: {
                            padding: 5
                        }
                    }],
                    yAxes: [{
                        gridLines: {
                            drawTicks: false,
                            drawBorder: true,
                            drawOnChartArea: false,
                            z: 1
                        },
                        ticks: {
                            padding: 5,
                            beginAtZero: true,
                            callback: function (value, index, values) {
                                return toNumber(value);
                            }
                        }
                    }]
                }
            }
        });
}

displayChartMonthlyStats('fullPricedChart', '#fullPricedChart');
displayChartMonthlyStats('employeeCountChart', '#employeeCountChart');
displayChartMonthlyStats('sendTicketsChart', '#sendTicketsChart');
displayChartMonthlyStats('sendTicketsPriceChart', '#sendTicketsPriceChart');
displayChartMonthlyStats('inAppTicketsChart', '#inAppTicketsChart');
displayChartMonthlyStats('inAppTicketsPriceChart', '#inAppTicketsPriceChart');
displayChartMonthlyStats('bicycleUsageChart', '#bicycleUsageChart');
displayChartMonthlyStats('poolCarUsageChart', '#poolCarUsageChart');
displayChartMonthlyStats('travelFreedomGroup1Chart', '#travelFreedomGroup1Chart');
displayChartMonthlyStats('travelFreedomGroup2Chart', '#travelFreedomGroup2Chart');
displayChartMonthlyStats('travelFreedomOtherGroupsChart', '#travelFreedomOtherGroupsChart');
displayChartMonthlyStats('travelFreedomConsentChart', '#travelFreedomConsentChart');
displayChartMonthlyStats('surveyChart', '#surveyChart');
